import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

class ConfirmDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            header: this.props.header,
            content: this.props.content,
            isShowing: this.props.isShowing,
            showFooter: this.props.showFooter,
            confirmButtonText: this.props.confirmButtonText,
            cancelButtonText: this.props.cancelButtonText,
            onConfirm: this.props.onConfirm,
            onCancel: this.props.onCancel
        };
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.setState({
            header: nextProps.header,
            content: nextProps.content,
            isShowing: nextProps.isShowing,
            showFooter: nextProps.showFooter,
            confirmButtonText: nextProps.confirmButtonText,
            cancelButtonText: nextProps.cancelButtonText,
            onConfirm: nextProps.onConfirm,
            onCancel: nextProps.onCancel
        });
    }

    render() {
        let {
            header,
            content,
            onConfirm,
            isShowing,
            showFooter,
            onCancel,
            confirmButtonText,
            cancelButtonText
        } = this.props;

        return (
            <Modal show={isShowing} onHide={onCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>{header}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="form-modal">
                    <p>{content}</p>
                </Modal.Body>
                {showFooter && (
                    <Modal.Footer>
                        {onConfirm && (
                            <Button
                                bsStyle="primary"
                                onClick={() => onConfirm()}
                            >
                                <i className="fa fa-check" />
                                {confirmButtonText}
                            </Button>
                        )}
                        <Button bsStyle="danger" onClick={() => onCancel()}>
                            <i className="fa fa-times" /> {cancelButtonText}
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
        );
    }
}

ConfirmDialog.propTypes = {
    header: PropTypes.string.isRequired,
    content: PropTypes.node.isRequired,
    isShowing: PropTypes.bool.isRequired,
    showFooter: PropTypes.bool,
    confirmButtonText: PropTypes.string,
    cancelButtonText: PropTypes.string,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func.isRequired
};

ConfirmDialog.defaultProps = {
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
    showFooter: true,
    isShowing: false
};

export default ConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/Dialog/ConfirmDialog.js